// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "assets_js_vendors_lottie_min_js") return "./js/chunks/9dae861608f49e84ffe9.js";
	if (chunkId === "assets_js_modules_main_js") return "./js/chunks/8ef15289f037781895a4.js";
	if (chunkId === "assets_js_modules_menubar_js") return "./js/chunks/504b8a9f099bd031e73a.js";
	if (chunkId === "assets_js_modules_popin_js") return "./js/chunks/df7fa83c444e96294452.js";
	if (chunkId === "assets_js_modules_popinOpen_js") return "./js/chunks/6bc246706776ca1b481e.js";
	if (chunkId === "assets_js_modules_windows_js") return "./js/chunks/2c414043a35bca717410.js";
	// return url for filenames based on template
	return undefined;
};